import { makeStyles } from '@material-ui/core/styles';
import { MOBILE_BREAKPOINT } from '../../../../config/constants';

export const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        gap: '25px',
        [theme.breakpoints.down('md')]: {
            marginLeft: '2rem',
            marginTop: '1.5rem',
            marginBottom: '1.5rem',
        },
        [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
            marginLeft: '1rem',
        },
        [theme.breakpoints.up('md')]: {
            marginBottom: '1rem',
        },
    },
    avatarContainer: {
        position: 'relative',
        width: '60px',
    },
    avatar: {
        borderRadius: '50% !important',
        border: `1.5px solid ${theme.palette.primary.main}`,
        marginRight: '20px',
        alignSelf: 'center',
        width: '65px !important',
        height: '65px !important',
        objectFit: 'cover',
        padding: '2px',
        [theme.breakpoints.up('xl')]: {
            width: '80px !important',
            height: '80px !important',
            padding: '3px',
        },
    },
    icon: {
        position: 'absolute',
        top: '50px',
        right: '0px',
        width: '20px',
        [theme.breakpoints.up('xl')]: {
            right: '-15px',
            width: '25px',
            top: '60px',
        },
    },
    profileLink: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textDecoration: 'none',
        marginLeft: '25px',
    },
    name: {
        color: theme.palette.secondary.dark,
        fontSize: '24px',
        fontWeight: 500,
        [theme.breakpoints.up('xl')]: {
            fontSize: '26px',
        },
    },
}));
